// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1_IbL","label":"LabeledBox_label__2nhG6"};